var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTwitter2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182.771,
    height: 150.295,
    viewBox: "0 0 182.771 150.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0.1;}.c{filter:url(#c);}.d{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 182.771,
    height: 150.295,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 37.156,
    y: 28.377,
    width: 108.145,
    height: 93.541,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.152,154.866c65.617,0,101.5-54.373,101.5-101.5,0-1.553,0-3.107-.074-4.587A73.08,73.08,0,0,0,184.4,30.29a72.4,72.4,0,0,1-20.491,5.622A35.651,35.651,0,0,0,179.594,16.16a72.236,72.236,0,0,1-22.637,8.655,35.692,35.692,0,0,0-61.7,24.412,32.69,32.69,0,0,0,.962,8.137A101.2,101.2,0,0,1,22.69,20.081a35.654,35.654,0,0,0,11.1,47.567,35.041,35.041,0,0,1-16.127-4.439v.444A35.71,35.71,0,0,0,46.288,98.644a35.56,35.56,0,0,1-9.4,1.258,34.06,34.06,0,0,1-6.732-.666,35.617,35.617,0,0,0,33.289,24.782,71.706,71.706,0,0,1-44.312,15.239,64.87,64.87,0,0,1-8.507-.518,99.385,99.385,0,0,0,54.521,16.127",
    transform: "translate(-6.13 -9.07)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.15,77.112c29.508,0,45.643-24.452,45.643-45.643,0-.7,0-1.4-.033-2.063a32.865,32.865,0,0,0,8.017-8.317,32.559,32.559,0,0,1-9.215,2.528,16.032,16.032,0,0,0,7.053-8.882,32.485,32.485,0,0,1-10.18,3.892A16.051,16.051,0,0,0,48.69,29.606a14.7,14.7,0,0,0,.432,3.659A45.508,45.508,0,0,1,16.054,16.5a16.034,16.034,0,0,0,4.99,21.391,15.758,15.758,0,0,1-7.252-2v.2A16.059,16.059,0,0,0,26.667,51.829a15.991,15.991,0,0,1-4.225.566,15.316,15.316,0,0,1-3.027-.3,16.017,16.017,0,0,0,14.97,11.145,32.247,32.247,0,0,1-19.927,6.853,29.172,29.172,0,0,1-3.826-.233A44.694,44.694,0,0,0,35.15,77.112",
    transform: "translate(41.52 29.81)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter2);
export default __webpack_public_path__ + "static/media/icon_twitter_2.c95902aca1fc9f51936c538677accc33.svg";
export { ForwardRef as ReactComponent };